import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import TruncateHTMLContent from './TruncateHTMLContent';

const HotelCancellationMessage = (props) => {
    const { message, showCancelMessageModel, setShowCancelMessageModel } = props;
    const navigate = useNavigate();

    const handleBackToHome = () => {
        setShowCancelMessageModel(false);
        sessionStorage.removeItem('isCancel')
        navigate('/hotels')
    }

    return (

        <Modal
            show={showCancelMessageModel}
            onHide={() => setShowCancelMessageModel(false)}
            dialogClassName="modal-90w"
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <div className='my-2 px-4 py-2'>
                <h2> Cancellation Request </h2>

                <div className="my-4">
                    <TruncateHTMLContent htmlContent={message} />
                </div>

                <center>
                    <button
                        type="button"
                        className='btn proceedbookingBtn'
                        onClick={() => handleBackToHome()}
                    >
                        Back to Home Page
                    </button>
                </center>

            </div>
        </Modal>

    )
}

export default HotelCancellationMessage
